(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brava-camino"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.brava-camino').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=(event,params={})=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...params});};
  track('brava_camino_view');
  root.querySelectorAll('[data-path]').forEach(button=>button.addEventListener('click',()=>{
    const camino=button.dataset.path;
    root.querySelectorAll('[data-path]').forEach(b=>b.setAttribute('aria-expanded',String(b===button)));
    root.querySelectorAll('[data-panel]').forEach(panel=>panel.hidden=panel.dataset.panel!==camino);
    track('brava_camino_select',{camino});
    root.querySelector('[data-panel="'+camino+'"] h2').focus({preventScroll:true});
  }));
  root.querySelectorAll('.bc-options button').forEach(button=>button.addEventListener('click',()=>{
    root.querySelector('.bc-question').hidden=true;
    root.querySelector('.bc-glp-offer').hidden=false;
    root.querySelector('.bc-glp-offer h2').focus({preventScroll:true});
  }));
  root.querySelectorAll('a[data-offer]').forEach(link=>link.addEventListener('click',()=>{
    track('brava_camino_offer_click',{camino:link.dataset.camino,offer:link.dataset.offer});
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brava-tap"]) return;
  try {
    
  (() => {
    const projectUrl = 'https://ebmvttxyfrcfmtcbtpuz.supabase.co';
    const publicKey = 'sb_publishable_JeuErHB5PPPwSPsZdN8i1w_H-8bX6a8';
    let clientPromise;
    function authClient() {
      if (!clientPromise) {
        clientPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.116.0/dist/umd/supabase.js';
          script.integrity = 'sha384-iLddHTLokph6Omwoyid4XKxHaWa6w41BnoEj0q5oOrzmYPpHIKt1wyjReA7s//pP';
          script.crossOrigin = 'anonymous';
          script.async = true;
          const timeout = setTimeout(() => { script.remove(); reject(new Error('sdk_unavailable')); }, 15000);
          script.onload = () => {
            clearTimeout(timeout);
            try {
              resolve(window.supabase.createClient(projectUrl, publicKey, {
                auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: 'brava-tap-auth-v1' }
              }));
            } catch (error) { reject(error); }
          };
          script.onerror = () => { clearTimeout(timeout); script.remove(); reject(new Error('sdk_unavailable')); };
          document.head.append(script);
        }).catch(error => { clientPromise = null; throw error; });
      }
      return clientPromise;
    }
    function mount(root) {
      if (root.dataset.tapMounted) return;
      root.dataset.tapMounted = 'true';
      const copy = JSON.parse(root.querySelector('[data-tap-copy]').textContent);
      const find = name => root.querySelector('[data-tap-' + name + ']');
      const button = find('button');
      const message = find('message');
      const token = (new URLSearchParams(window.location.search).get('token') || '').trim();
      const format = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
      const panels = { progress: 'dashboard', gate: 'gate', email: 'email-form', otp: 'otp-form', claimed: 'claimed', profile: 'profile-panel' };
      let displayName = null;
      let profileKnown = false;
      let profileOverride = false;
      let profileMode = null;
      let profilePrompted = false;
      let profileBusy = false;
      let needsNewName = false;
      let personalFeedbackTimer;
      let profileEpoch = 0;
      let historySequence = 0;
      let streakCelebration = false;
      let view = 'loading';
      let gateAction = 'activate';
      let intent = 'activate';
      let activationEnabled = false;
      let busy = false;
      let ready = false;
      let inactive = false;
      let amount = null;
      let current = null;
      let celebrationTimer;
      let timer;
      let cooldownTimer;
      let resendAt = 0;
      let email = '';
      let auth;
      let authSubscription;
      let authEpoch = 0;
      let sessionIdentity = null;
      let pendingRefresh = false;
      let destroyed = false;
      const entryHadLog = new URLSearchParams(window.location.search).get('action') === 'log';
      const navigationType = window.performance?.getEntriesByType?.('navigation')[0]?.type;
      const restoredEntry = navigationType === 'reload' || navigationType === 'back_forward' || document.wasDiscarded === true;
      const entryConsumed = window.history.state?.bravaTapLogConsumed === token;
      let autoLogPending = entryHadLog && !!token && !restoredEntry && !entryConsumed && window.Shopify?.designMode !== true;
      let autoLogAttempted = false;
      let autoLogReady = false;
      let autoLogSuppressed = false;
      let autoFeedbackTimer;
      function rememberLogEntry(removeAction) {
        const url = new URL(window.location.href);
        if (removeAction) {
          const otherActions = url.searchParams.getAll('action').filter(value => value !== 'log');
          url.searchParams.delete('action');
          otherActions.forEach(value => url.searchParams.append('action', value));
        }
        const state = window.history.state;
        window.history.replaceState({ ...(state && typeof state === 'object' ? state : {}), bravaTapLogConsumed: token }, '', url.pathname + url.search + url.hash);
      }
      function consumeAutoLog() {
        autoLogPending = false;
        autoLogReady = false;
        if (entryHadLog) {
          try { rememberLogEntry(true); } catch (_) { autoLogSuppressed = true; }
        }
      }
      function maybeAutoLog() {
        if (!autoLogPending || !autoLogReady || autoLogAttempted || autoLogSuppressed || busy || destroyed || view !== 'progress' || !ready) return;
        autoLogAttempted = true;
        autoLogPending = false;
        autoLogReady = false;
        register(true);
      }
      if (entryHadLog) {
        try { rememberLogEntry(!autoLogPending); }
        catch (_) { autoLogPending = false; autoLogSuppressed = true; }
      }
      function clearProgress() {
        hidePersonalText();
        clearHistory();
        ready = false;
        current = null;
        amount = null;
        find('dashboard').hidden = true;
        find('state').hidden = true;
        find('total').textContent = '—';
        find('goal').textContent = '—';
        find('count').textContent = '';
        find('percent').textContent = '0%';
        find('progress').setAttribute('aria-valuenow', '0');
        find('fill').style.width = '0%';
        button.textContent = '';
        clearTimeout(celebrationTimer);
        find('celebration').hidden = true;
        find('confetti').replaceChildren();
      }
      function setView(next) {
        view = next;
        root.dataset.tapView = next;
        find('journal').hidden = next !== 'progress';
        Object.entries(panels).forEach(([name, element]) => { find(element).hidden = name !== next; });
        find('retry').hidden = true;
        if (next !== 'progress') clearProgress();
      }
      function updateControls() {
        root.setAttribute('aria-busy', String(busy));
        root.querySelectorAll('button, input').forEach(el => { el.disabled = busy || (profileBusy && find('profile-panel').contains(el)); });
        button.disabled = busy || !ready || view !== 'progress';
        find('start').disabled = busy || inactive || (gateAction === 'activate' && !activationEnabled);
        const seconds = Math.max(0, Math.ceil((resendAt - Date.now()) / 1000));
        find('resend').disabled = busy || seconds > 0;
        find('resend').textContent = seconds ? copy.resend_wait.replace('__SECONDS__', seconds) : copy.resend;
        find('send').textContent = busy && view === 'email' ? copy.sending : copy.send_code;
        find('confirm').textContent = busy && view === 'otp' ? copy.confirming : copy.confirm_code;
        if (ready) button.textContent = copy.register.replace('__AMOUNT__', format.format(amount));
      }
      function scheduleRefresh() {
        clearTimeout(timer);
        if (view === 'progress' && !destroyed) timer = setTimeout(refresh, 60000);
      }
      async function operation(work, fallback) {
        if (busy || destroyed || !root.isConnected) return;
        busy = true;
        clearTimeout(autoFeedbackTimer);
        hidePersonalFeedback();
        clearTimeout(timer);
        message.textContent = '';
        updateControls();
        try { await work(); }
        catch (error) {
          if (error.message === 'stale_session') {
            pendingRefresh = true;
          } else if (error.message === 'session_required') {
            showGate('sign_in_as_owner');
            message.textContent = copy.session_required;
          } else {
            message.textContent = copy[fallback] || copy.connection_error;
            if (view === 'loading') find('retry').hidden = false;
          }
        } finally {
          busy = false;
          updateControls();
          if (pendingRefresh) { pendingRefresh = false; setTimeout(refresh, 0); }
          else scheduleRefresh();
          maybeAutoLog();
        }
      }
      async function readOwnProfile(session, signal) {
        const controller = new AbortController();
        const abort = () => controller.abort();
        signal.addEventListener('abort',abort,{once:true});
        if (signal.aborted) abort();
        const timeout = setTimeout(abort,2000);
        try {
          const response = await fetch(projectUrl + '/functions/v1/tap-profile?token=' + encodeURIComponent(token), {
            method:'GET',headers:{apikey:publicKey,Authorization:'Bearer ' + session.access_token},mode:'cors',credentials:'omit',cache:'no-store',signal:controller.signal
          });
          const body = await response.json();
          return response.ok && body.ok === true && Object.prototype.hasOwnProperty.call(body,'profile') ? {profile:body.profile} : {};
        } catch (_) { return {}; }
        finally { clearTimeout(timeout); signal.removeEventListener('abort',abort); }
      }
      async function api(resource, method = 'GET') {
        auth = auth || await authClient();
        const { data, error } = await auth.auth.getSession();
        if (error) throw error;
        const session = data.session;
        if (method === 'POST' && !session) throw new Error('session_required');
        const headers = { apikey: publicKey };
        if (session) headers.Authorization = 'Bearer ' + session.access_token;
        if (resource === 'claim-tap') headers['Content-Type'] = 'application/json';
        const epoch = authEpoch;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(projectUrl + '/functions/v1/' + resource + (resource === 'tap' ? '?token=' + encodeURIComponent(token) : ''), {
            method, headers, mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal,
            ...(resource === 'claim-tap' ? { body: JSON.stringify({ token }) } : {})
          });
          const body = await response.json();
          if (resource === 'tap' && method === 'GET' && response.ok && body.owner === true && body.claimed === true && session) Object.assign(body, await readOwnProfile(session, controller.signal));
          if (epoch !== authEpoch || destroyed) throw new Error('stale_session');
          return { status: response.status, ok: response.ok, body, authenticated: !!session };
        } finally { clearTimeout(timeout); }
      }
      function showGate(action, wrongOwner = false) {
        resetProfile();
        setView('gate');
        gateAction = action === 'activate' ? 'activate' : 'sign_in_as_owner';
        const activate = gateAction === 'activate';
        find('gate-title').textContent = activate ? copy.activation_title : copy.owner_title;
        find('gate-body').textContent = activate ? copy.activation_body : wrongOwner ? copy.wrong_owner : copy.owner_body;
        find('start').textContent = activate ? copy.activation_button : wrongOwner ? copy.change_email : copy.owner_button;
        find('once').hidden = !activate;
        if (activate && !activationEnabled) message.textContent = copy.activation_unavailable;
      }
      function route(result, afterSignIn = false) {
        const data = result.body;
        if (data.error === 'invalid_or_inactive_tag' || result.status === 404 || result.status === 410) {
          inactive = true;
          setView('inactive');
          message.textContent = copy.inactive;
          return false;
        }
        if (data.claimed === false && data.next_action === 'activate') {
          autoLogSuppressed = true;
          autoLogPending = false;
          autoLogReady = false;
          activationEnabled = data.activation?.enabled === true;
          showGate('activate');
          return false;
        }
        if ((data.claimed === true && data.owner !== true) || result.status === 401 || result.status === 403) {
          showGate('sign_in_as_owner', afterSignIn && result.authenticated);
          return false;
        }
        if (!result.ok || data.ok !== true) throw new Error('api_failure');
        if (data.claimed === true && data.owner === true && data.next_action === 'open_progress' && result.authenticated) {
          if (Object.prototype.hasOwnProperty.call(data, 'profile') && !profileBusy && !profileOverride) {
            profileKnown = true;
            displayName = cleanName(data.profile?.display_name);
          }
          if (needsNewName && !displayName) {
            setView('profile');
            showNameForm('new');
            return false;
          }
          needsNewName = false;
          render(data);
          updatePersonalization();
          return true;
        }
        setView('loading');
        throw new Error('unknown_state');
      }
      function render(data) {
        const total = data.today_total_ml, goal = data.daily_goal_ml, count = data.checkins_today;
        if (![total, goal, count, data.amount_ml, data.progress_percent].every(Number.isFinite) || total < 0 || goal <= 0 || count < 0 || data.amount_ml <= 0) throw new Error('state');
        setView('progress');
        amount = data.amount_ml;
        const percent = Math.min(100, Math.max(0, data.progress_percent));
        find('total').textContent = format.format(total);
        find('goal').textContent = format.format(goal);
        find('percent').textContent = Math.round(percent) + '%';
        find('progress').setAttribute('aria-valuenow', String(Math.round(percent)));
        find('fill').style.width = percent + '%';
        find('complete').hidden = total < goal;
        find('count').textContent = count === 1 ? copy.count_one : copy.count_many.replace('__COUNT__', format.format(count));
        find('count').hidden = false;
        find('state').hidden = false;
        ready = true;
        current = { total, goal };
        streakCelebration = false;
        find('celebration-streak').hidden = true;
        loadHistory();
      }
      function cleanName(value) {
        if (typeof value !== 'string') return null;
        const name = value.trim().normalize('NFC');
        return [...name].length <= 40 && /[\p{L}\p{N}\p{P}\p{S}]/u.test(name) && !/\p{Cc}/u.test(name) ? name : null;
      }
      function hidePersonalFeedback() {
        clearTimeout(personalFeedbackTimer);
        find('personal-feedback').hidden = true;
        find('personal-feedback').textContent = '';
      }
      function hidePersonalText() {
        find('greeting').hidden = true;
        find('greeting-title').textContent = '';
        find('personal-complete').hidden = true;
        find('personal-complete').textContent = '';
        find('complete-copy').textContent = copy.complete;
        hidePersonalFeedback();
      }
      function resetProfile() {
        profileEpoch++;
        displayName = null; profileKnown = false; profileOverride = false; profileMode = null; profilePrompted = false; needsNewName = false;
        find('profile-panel').hidden = true;
        find('name').value = '';
        find('name-error').textContent = '';
        hidePersonalText();
      }
      function invitationKey() { return 'brava-tap-name-invited:' + (sessionIdentity || 'session'); }
      function hasInvited() {
        try { return profilePrompted || sessionStorage.getItem(invitationKey()) === 'yes'; }
        catch (_) { return profilePrompted; }
      }
      function rememberInvitation() {
        profilePrompted = true;
        try { sessionStorage.setItem(invitationKey(), 'yes'); } catch (_) {}
      }
      function updatePersonalization() {
        if (view !== 'progress') return;
        find('greeting').hidden = !displayName;
        if (displayName) {
          const hour = Number(new Intl.DateTimeFormat('en-US',{timeZone:'America/Mexico_City',hour:'2-digit',hourCycle:'h23'}).format(new Date()));
          const key = hour >= 5 && hour < 12 ? 'hello_morning' : hour >= 12 && hour < 19 ? 'hello_day' : 'hello_night';
          find('greeting-title').textContent = copy[key].replace('__NAME__',displayName);
        }
        if (profileMode && !displayName) find('profile-panel').hidden = false;
        else if (profileMode === 'edit') find('profile-panel').hidden = false;
        else if (profileKnown && !displayName && !hasInvited()) showNameForm('invite');
      }
      function showNameForm(mode) {
        profileMode = mode;
        if (mode === 'invite') rememberInvitation();
        find('profile-panel').hidden = false;
        find('profile-eyebrow').textContent = mode === 'new' ? copy.name_new : mode === 'invite' ? copy.name_invite : '';
        find('name').value = displayName || '';
        find('name-error').textContent = '';
        find('name-save').textContent = mode === 'new' ? copy.name_continue : copy.name_save;
        find('name-skip').hidden = mode === 'new';
        find('name-skip').textContent = mode === 'edit' ? copy.name_cancel : copy.name_skip;
        if (mode === 'edit') find('name').focus();
      }
      async function saveName(event) {
        event.preventDefault();
        if (busy || profileBusy || !profileMode) return;
        const name = cleanName(find('name').value);
        if (!name) { find('name-error').textContent = copy.name_invalid; return; }
        const epoch = authEpoch, pEpoch = profileEpoch;
        const mode = profileMode;
        profileBusy = true; find('name-error').textContent = ''; updateControls();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(),15000);
        try {
          const {data,error} = await auth.auth.getSession();
          if (error || !data.session) throw new Error('session_required');
          const response = await fetch(projectUrl + '/functions/v1/tap-profile',{
            method:'PUT',mode:'cors',credentials:'omit',cache:'no-store',signal:controller.signal,
            headers:{apikey:publicKey,Authorization:'Bearer ' + data.session.access_token,'Content-Type':'application/json'},
            body:JSON.stringify({token,display_name:name})
          });
          const body = await response.json();
          if (epoch !== authEpoch || pEpoch !== profileEpoch || destroyed) return;
          if (response.status === 401 || response.status === 403) { showGate('sign_in_as_owner'); return; }
          const saved = cleanName(body.profile?.display_name);
          if (!response.ok || body.ok !== true || !saved) throw new Error('profile_failed');
          displayName = saved; profileKnown = true; profileOverride = true; profileMode = null; needsNewName = false;
          rememberInvitation(); find('profile-panel').hidden = true; find('name').value = '';
          if (mode === 'new') { await refresh(); }
          else { updatePersonalization(); message.textContent = copy.name_saved; }
        } catch (error) {
          if (epoch !== authEpoch || pEpoch !== profileEpoch || destroyed) return;
          if (error.message === 'session_required') showGate('sign_in_as_owner');
          else find('name-error').textContent = copy.name_error;
        } finally { clearTimeout(timeout); profileBusy = false; updateControls(); }
      }
      function showPersonalFeedback(automatic) {
        hidePersonalFeedback();
        if (!automatic || !displayName || !current) return;
        find('personal-feedback').textContent = copy.personal_total.replace('__TOTAL__',format.format(current.total)).replace('__NAME__',displayName);
        find('personal-feedback').hidden = false;
        personalFeedbackTimer = setTimeout(hidePersonalFeedback,2000);
      }
      function personalizeCelebration() {
        find('personal-complete').hidden = !displayName;
        find('personal-complete').textContent = displayName ? copy.personal_complete.replace('__NAME__',displayName) : '';
        find('complete-copy').textContent = displayName ? copy.complete_named : copy.complete;
      }
      find('profile-panel').addEventListener('submit',saveName);
      find('name-edit').addEventListener('click',() => { if (!busy && !profileBusy && view === 'progress') showNameForm('edit'); });
      find('name-skip').addEventListener('click',() => {
        if (profileBusy || profileMode === 'new') return;
        rememberInvitation(); profileMode = null; find('profile-panel').hidden = true; find('name').value = ''; find('name-error').textContent = '';
      });
      function clearHistory() {
        historySequence++;
        streakCelebration = false;
        find('history-content').hidden = true;
        find('history-status').textContent = '';
        find('history-retry').hidden = true;
        find('week').replaceChildren();
        find('days').replaceChildren();
        ['streak','streak-caption','best','week-summary','month-goals','month-best','month-water','celebration-streak'].forEach(key => { find(key).textContent = ''; });
      }
      const dayWords = n => n === 1 ? copy.streak_one : copy.streak_many.replace('__COUNT__', format.format(n));
      function historyElement(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }
      function renderHistory(h) {
        const metrics = ['current_streak','best_streak','best_streak_last_30','completed_days_this_week','completed_days_last_7','completed_days_last_30','total_ml_last_30'];
        if (!h || h.timezone !== 'America/Mexico_City' || h.best_streak_scope !== 'all_time' || !/^\d{4}-\d{2}-\d{2}$/.test(h.today) || !Array.isArray(h.days) || h.days.length !== 30 || !Array.isArray(h.week) || h.week.length !== 7 || !metrics.every(k => Number.isFinite(h[k]) && h[k] >= 0)) throw new Error('history_state');
        if (![...h.days,...h.week].every(d => /^\d{4}-\d{2}-\d{2}$/.test(d.date) && Number.isFinite(d.total_ml) && d.total_ml >= 0 && Number.isFinite(d.goal_ml) && d.goal_ml > 0 && typeof d.completed === 'boolean')) throw new Error('history_days');
        const shortDate = new Intl.DateTimeFormat('es-MX', { timeZone: h.timezone, weekday: 'short', day: 'numeric' });
        const longDate = new Intl.DateTimeFormat('es-MX', { timeZone: h.timezone, dateStyle: 'full' });
        const dateObject = d => new Date(d + 'T12:00:00Z');
        find('streak').textContent = h.current_streak ? dayWords(h.current_streak) : '';
        find('streak-caption').textContent = h.current_streak ? copy.streak_following : h.has_history ? copy.streak_restart : copy.streak_new;
        find('best').textContent = copy.best_copy.replace('__DAYS__', dayWords(h.best_streak));
        const week = document.createDocumentFragment();
        h.week.forEach((d,i) => {
          const state = d.is_future ? 'future' : d.completed ? 'complete' : d.date === h.today ? 'today' : 'past';
          const label = longDate.format(dateObject(d.date)) + ': ' + copy['day_' + (state === 'complete' ? 'complete' : state)] + (state !== 'future' ? ', ' + format.format(d.total_ml) + ' ml' : '');
          const item = historyElement('li'); item.setAttribute('aria-label',label);
          const letter = historyElement('span','',copy.weekday_letters.split(',')[i]); letter.setAttribute('aria-hidden','true');
          const dot = historyElement('span','brava-tap__day-dot',state === 'complete' ? '✓' : ''); dot.dataset.state = state; dot.setAttribute('aria-hidden','true');
          if (d.date === h.today) item.setAttribute('aria-current','date');
          item.append(letter,dot); week.append(item);
        });
        find('week').replaceChildren(week);
        find('week-summary').textContent = h.completed_days_this_week === 1 ? copy.week_one : copy.week_many.replace('__COUNT__',format.format(h.completed_days_this_week));
        const days = document.createDocumentFragment();
        h.days.slice(0,7).forEach(d => {
          const item = historyElement('li'), row = historyElement('div','brava-tap__day-row');
          const date = historyElement('time','',shortDate.format(dateObject(d.date))); date.dateTime = d.date;
          const total = historyElement('span','',format.format(d.total_ml) + ' ml');
          if (d.completed) total.append(historyElement('small','',copy.day_goal));
          row.append(date,total);
          const track = historyElement('div','brava-tap__day-track'), fill = historyElement('i');
          fill.style.width = Math.min(100,Math.max(0,d.total_ml / d.goal_ml * 100)) + '%';
          track.setAttribute('aria-hidden','true'); track.append(fill); item.append(row,track); days.append(item);
        });
        find('days').replaceChildren(days);
        find('history-empty').hidden = h.has_history;
        find('month-goals').textContent = format.format(h.completed_days_last_30);
        find('month-best').textContent = dayWords(h.best_streak_last_30);
        find('month-water').textContent = new Intl.NumberFormat('en-US',{minimumFractionDigits:1,maximumFractionDigits:1}).format(h.total_ml_last_30 / 1000) + ' L';
        find('history-content').hidden = false;
        find('history-status').textContent = '';
        if (streakCelebration && !find('celebration').hidden && h.current_streak >= 2) {
          find('celebration-streak').textContent = copy.streak_toast.replace('__COUNT__',format.format(h.current_streak));
          find('celebration-streak').hidden = false;
        }
      }
      async function loadHistory() {
        if (view !== 'progress' || !ready || destroyed) return;
        const sequence = ++historySequence;
        find('history-status').textContent = copy.history_loading;
        find('history-retry').hidden = true;
        try {
          const result = await api('tap?token=' + encodeURIComponent(token) + '&include=history');
          if (sequence !== historySequence || view !== 'progress' || destroyed) return;
          if (!result.authenticated || result.status === 401 || result.status === 403 || result.body.owner === false || result.body.claimed === false) {
            clearHistory();
            showGate('sign_in_as_owner');
            return;
          }
          if (!result.ok || result.body.ok !== true || result.body.owner !== true || result.body.claimed !== true) throw new Error('history_api');
          renderHistory(result.body.history);
        } catch (_) {
          if (sequence !== historySequence || view !== 'progress' || destroyed) return;
          find('history-content').hidden = true;
          find('history-status').textContent = copy.history_error;
          find('history-retry').hidden = false;
        }
      }
      find('history-retry').addEventListener('click',loadHistory);
      function celebrate() {
        const layer = find('confetti');
        const toast = find('celebration');
        clearTimeout(celebrationTimer);
        layer.replaceChildren();
        toast.hidden = false;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const colors = ['#6F1738', '#F7F1E8', '#C48E9D', '#8C2036'];
          const paths = [
            'M8 2Q14 6 21 2L20 23Q22 28 28 29L33 31Q35 35 30 36H16L13 33V37H7V28Q12 19 8 2Z',
            '',
            'M20 3L24 14L36 15L27 23L30 35L20 28L10 35L13 23L4 15L16 14Z',
            'M20 34L6 20C-3 10 10 0 20 11C30 0 43 10 34 20Z'
          ];
          const fragment = document.createDocumentFragment();
          for (let i = 0; i < 36; i++) {
            const particle = document.createElement('i');
            particle.className = 'brava-tap__particle';
            const side = i % 3;
            const x = side === 0 ? 3 : side === 1 ? 97 : 30 + Math.random() * 40;
            const y = side === 2 ? 102 : 68 + Math.random() * 24;
            const dx = (side === 0 ? 1 : side === 1 ? -1 : Math.random() - .5) * (12 + Math.random() * 28);
            const vars = {x: x + '%', y: y + '%', dx: dx + 'vw', rise: -(30 + Math.random() * 40) + 'vh', drift: (dx + (Math.random() - .5) * 16) + 'vw', fall: (108 - y) + 'vh', turn: (Math.random() - .5) * 180 + 'deg', 'end-turn': (Math.random() - .5) * 440 + 'deg', color: colors[(Math.floor(i / 4) + i) % 4], size: (i % 4 === 0 ? 22 : 12 + Math.random() * 8) + 'px', duration: (2300 + Math.random() * 300) + 'ms', delay: Math.random() * 160 + 'ms'};
            Object.entries(vars).forEach(([key, value]) => particle.style.setProperty('--' + key, value));
            if (i % 4 === 1) {
              const letter = document.createElement('span');
              letter.textContent = 'B';
              particle.append(letter);
            } else {
              const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              svg.setAttribute('viewBox', '0 0 40 40');
              svg.setAttribute('focusable', 'false');
              const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              path.setAttribute('d', paths[i % 4]);
              path.setAttribute('fill', 'currentColor');
              svg.append(path);
              particle.append(svg);
            }
            fragment.append(particle);
          }
          layer.append(fragment);
        }
        celebrationTimer = setTimeout(() => { layer.replaceChildren(); toast.hidden = true; }, 3250);
      }
      async function refresh() {
        await operation(async () => { route(await api('tap')); }, 'connection_error');
      }
      async function register(automatic = false) {
        if (view !== 'progress' || !ready || busy) return;
        const previous = current;
        await operation(async () => {
          button.textContent = copy.saving;
          let result;
          try { result = await api('tap', 'POST'); }
          finally { if (automatic) consumeAutoLog(); }
          if (!route(result)) return;
          const feedback = result.body.duplicate_prevented === true ? copy.duplicate : (automatic ? copy.auto_success : copy.success).replace('__AMOUNT__', format.format(amount));
          message.textContent = feedback;
          showPersonalFeedback(automatic && result.body.duplicate_prevented !== true);
          if (automatic) autoFeedbackTimer = setTimeout(() => { if (message.textContent === feedback) message.textContent = ''; }, 2000);
          if (result.body.duplicate_prevented !== true && previous && previous.total < previous.goal && previous.total < current.goal && current.total >= current.goal) { streakCelebration = true; personalizeCelebration(); celebrate(); }
        }, 'error');
      }
      function beginEmail() {
        setView('email');
        message.textContent = '';
        find('code').value = '';
        updateControls();
        find('email').focus();
      }
      function startCooldown() {
        resendAt = Date.now() + 60000;
        clearInterval(cooldownTimer);
        cooldownTimer = setInterval(() => { updateControls(); if (Date.now() >= resendAt) clearInterval(cooldownTimer); }, 1000);
      }
      async function sendCode() {
        if (view === 'otp' && Date.now() < resendAt) return;
        if (view === 'email' && !find('email-form').reportValidity()) return;
        await operation(async () => {
          email = find('email').value.trim();
          auth = auth || await authClient();
          const { error } = await auth.auth.signInWithOtp({ email, options: { shouldCreateUser: intent === 'activate' } });
          if (error) {
            if (error.status === 429 || error.code === 'over_email_send_rate_limit') { startCooldown(); message.textContent = copy.rate_limit; return; }
            throw error;
          }
          setView('otp');
          find('code').value = '';
          startCooldown();
          setTimeout(() => { if (view === 'otp') find('code').focus(); }, 0);
        }, 'auth_error');
      }
      async function claim() {
        message.textContent = copy.claiming;
        try {
          const result = await api('claim-tap', 'POST');
          if (result.status === 409 || result.body.error === 'already_claimed') {
            showGate('sign_in_as_owner', true);
            message.textContent = '';
            return;
          }
          if (result.status === 401) throw new Error('session_required');
          if (result.status === 404) { route(result); return; }
          if (!result.ok || result.body.ok !== true || result.body.claimed !== true) throw new Error('claim_failed');
          consumeAutoLog();
          needsNewName = result.body.already_owned !== true;
          setView('claimed');
          message.textContent = '';
          await new Promise(resolve => setTimeout(resolve, 1500));
          route(await api('tap'), true);
        } catch (error) {
          if (error.message === 'session_required' || error.message === 'stale_session') throw error;
          showGate('activate');
          gateAction = 'claim_retry';
          find('start').textContent = copy.claim_retry;
          message.textContent = copy.claim_error;
        }
      }
      async function confirmCode() {
        if (!find('otp-form').reportValidity()) return;
        await operation(async () => {
          const { data, error } = await auth.auth.verifyOtp({ email, token: find('code').value.trim(), type: 'email' });
          find('code').value = '';
          if (error || !data.session) throw new Error('invalid_otp');
          pendingRefresh = false;
          if (intent === 'activate') await claim();
          else autoLogReady = route(await api('tap'), true);
        }, 'otp_error');
      }
      async function boot() {
        await operation(async () => {
          auth = await authClient();
          if (!authSubscription) {
            const { data } = await auth.auth.getSession();
            sessionIdentity = data.session?.user?.id || null;
            authSubscription = auth.auth.onAuthStateChange((event, session) => {
              const identity = session?.user?.id || null;
              if (identity !== sessionIdentity || event === 'SIGNED_OUT') {
                resetProfile();
                sessionIdentity = identity;
                authEpoch++;
                clearProgress();
                if (busy) pendingRefresh = true;
                else if (!['email', 'otp'].includes(view)) setTimeout(refresh, 0);
              }
            }).data.subscription;
          }
          autoLogReady = route(await api('tap'));
        }, 'connection_error');
      }
      find('start').addEventListener('click', () => {
        if (busy || inactive) return;
        if (gateAction === 'claim_retry') { operation(claim, 'claim_error'); return; }
        if (gateAction === 'activate' && !activationEnabled) return;
        intent = gateAction === 'activate' ? 'activate' : 'sign_in';
        beginEmail();
      });
      find('email-form').addEventListener('submit', event => { event.preventDefault(); sendCode(); });
      find('otp-form').addEventListener('submit', event => { event.preventDefault(); confirmCode(); });
      find('resend').addEventListener('click', sendCode);
      find('change-email').addEventListener('click', beginEmail);
      find('back').addEventListener('click', () => { message.textContent = ''; showGate(intent === 'activate' ? 'activate' : 'sign_in_as_owner'); updateControls(); });
      find('code').addEventListener('input', () => { find('code').value = find('code').value.replace(/\D/g, ''); });
      find('retry').addEventListener('click', boot);
      find('signout').addEventListener('click', () => operation(async () => {
        clearProgress();
        const { error } = await auth.auth.signOut({ scope: 'local' });
        if (error) throw error;
        route(await api('tap'));
      }, 'connection_error'));
      button.addEventListener('click', () => register());
      const onVisibility = () => { if (!document.hidden && ['progress', 'gate'].includes(view)) refresh(); };
      const onPageHide = () => { autoLogSuppressed = true; consumeAutoLog(); };
      const onPageShow = event => { if (event.persisted) { onPageHide(); clearProgress(); boot(); } };
      document.addEventListener('visibilitychange', onVisibility);
      window.addEventListener('pageshow', onPageShow);
      window.addEventListener('pagehide', onPageHide);
      const unload = event => {
        if (!event.target.contains(root)) return;
        destroyed = true;
        clearTimeout(personalFeedbackTimer);
        clearTimeout(timer); clearTimeout(celebrationTimer); clearTimeout(autoFeedbackTimer); clearInterval(cooldownTimer);
        authSubscription?.unsubscribe();
        document.removeEventListener('visibilitychange', onVisibility);
        window.removeEventListener('pageshow', onPageShow);
        window.removeEventListener('pagehide', onPageHide);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      if (!token) { setView('inactive'); message.textContent = copy.missing; return; }
      boot();
    }
    const init = () => document.querySelectorAll('[data-brava-tap]').forEach(mount);
    init();
    document.addEventListener('shopify:section:load', init);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-limonada"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-limonada-page]:not([data-ls-ready])').forEach((root) => {
      root.dataset.lsReady = 'true';
      const form = root.querySelector('.ls-form');
      const qty = root.querySelector('[data-ls-qty]');
      const mainButton = root.querySelector('.ls-add');
      const sticky = root.querySelector('[data-ls-sticky]');
      const stickyButton = root.querySelector('[data-ls-sticky-submit]');
      const price = root.querySelector('[data-ls-price]');
      const stickyPrice = root.querySelector('[data-ls-sticky-price]');
      const variant = root.querySelector('[data-ls-variant]');
      const clampQuantity = (value) => {
        const min = Number(qty.min || 1); const max = qty.max ? Number(qty.max) : Infinity; const step = Number(qty.step || 1);
        return Math.min(max, Math.max(min, min + Math.round((value - min) / step) * step));
      };
      root.querySelector('[data-ls-minus]')?.addEventListener('click', () => { qty.value = clampQuantity(Number(qty.value) - Number(qty.step || 1)); qty.dispatchEvent(new Event('change', { bubbles: true })); });
      root.querySelector('[data-ls-plus]')?.addEventListener('click', () => { qty.value = clampQuantity(Number(qty.value) + Number(qty.step || 1)); qty.dispatchEvent(new Event('change', { bubbles: true })); });
      qty?.addEventListener('change', () => { qty.value = clampQuantity(Number(qty.value) || 1); });
      variant?.addEventListener('change', () => {
        const option = variant.selectedOptions[0]; const available = option.dataset.available === 'true';
        price.textContent = option.dataset.price; stickyPrice.textContent = option.dataset.price;
        mainButton.disabled = !available; stickyButton.disabled = !available;
        root.querySelector('[data-ls-submit-text]').textContent = available ? 'Agregar al carrito' : 'Agotado';
        stickyButton.textContent = available ? 'Agregar' : 'Agotado';
        window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);
      });
      if ('IntersectionObserver' in window && mainButton && sticky) {
        const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; sticky.classList.toggle('is-visible', !entry.isIntersecting); }, { threshold: .05 });
        observer.observe(mainButton);
        const visibleMedia = new Set();
        const mediaObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.isIntersecting ? visibleMedia.add(entry.target) : visibleMedia.delete(entry.target));
          sticky.classList.toggle('is-media-hidden', visibleMedia.size > 0);
        }, { threshold: .12 });
        root.querySelectorAll('.ls-editorial-preview__drink,.ls-lifestyle__portrait').forEach((media) => mediaObserver.observe(media));
      }
      form?.addEventListener('submit', () => { stickyButton?.setAttribute('aria-disabled', 'true'); setTimeout(() => stickyButton?.removeAttribute('aria-disabled'), 1400); });
      root.querySelectorAll('details').forEach((detail) => detail.addEventListener('toggle', () => { detail.querySelector('summary')?.setAttribute('aria-expanded', String(detail.open)); }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
